import Axios from "axios";
import { baseURL, getHrmEmployeeSalaryDistribution } from "@/store/api";
import {
  SET_SALARY_INFO_LIST,
  SET_SALARY_INFO_DETAILS,
  UNSET_SALARY_INFO_DETAILS,
  SET_EMPLOYEE_SALARY_DISTRIBUTION,
  UNSET_EMPLOYEE_SALARY_DISTRIBUTION
} from "@/store/mutation-types";

// Create axios instance with proper base URL
const apiClient = Axios.create({
  baseURL: baseURL + '/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// initial state
const state = {
  salaryInfoList: [],
  salaryInfoDetails: null,
  getHrmEmployeeSalaryDistribution: null,
  loading: false,
};

const getters = {
  getSalaryInfoList(state) {
    return state.salaryInfoList;
  },
  getSalaryInfoDetails(state) {
    return state.salaryInfoDetails;
  },
  getSalaryInfoLoading(state) {
    return state.loading;
  },
  getHrmEmployeeSalaryDistribution(state) {
    return state.getHrmEmployeeSalaryDistribution;
  },
};

const mutations = {
  [SET_SALARY_INFO_LIST](state, data) {
    state.salaryInfoList = data;
  },
  [SET_SALARY_INFO_DETAILS](state, data) {
    state.salaryInfoDetails = data;
  },
  [UNSET_SALARY_INFO_DETAILS](state) {
    state.salaryInfoDetails = null;
  },
  [SET_EMPLOYEE_SALARY_DISTRIBUTION](state, data) {
    state.getHrmEmployeeSalaryDistribution = data;
  },
  [UNSET_EMPLOYEE_SALARY_DISTRIBUTION](state) {
    state.getHrmEmployeeSalaryDistribution = null;
  },
  SET_SALARY_INFO_LOADING(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  getSalaryInfoList({ commit }) {
    commit("SET_SALARY_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      apiClient.get('/auth/hrm/get-salary-info-list')
        .then(function (response) {
          commit('SET_SALARY_INFO_LIST', response.data.data);
          commit("SET_SALARY_INFO_LOADING", false);
          resolve(response);
        })
        .catch(function (error) {
          commit('SET_SALARY_INFO_LIST', []);
          commit("SET_SALARY_INFO_LOADING", false);
          reject(error);
        });
    });
  },

  getSalaryInfoByEmployee({ commit }, employeeId) {
    commit("SET_SALARY_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      apiClient.get(`/auth/hrm/get-salary-info-by-employee/${employeeId}`)
        .then(function (response) {
          commit('SET_SALARY_INFO_LIST', response.data.data || []);
          commit("SET_SALARY_INFO_LOADING", false);
          resolve(response);
        })
        .catch(function (error) {
          commit('SET_SALARY_INFO_LIST', []);
          commit("SET_SALARY_INFO_LOADING", false);
          
          // Return a mock response object instead of rejecting
          const mockResponse = {
            data: {
              success: false,
              data: [],
              message: error.response?.data?.message || error.message || 'Failed to fetch salary information'
            }
          };
          resolve(mockResponse);
        });
    });
  },

  getSalaryInfoById({ commit }, id) {
    commit("SET_SALARY_INFO_LOADING", true);
    return new Promise((resolve, reject) => {
      apiClient.get(`/auth/hrm/get-salary-info-by-id/${id}`)
        .then(function (response) {
          commit('SET_SALARY_INFO_DETAILS', response.data.data);
          commit("SET_SALARY_INFO_LOADING", false);
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SALARY_INFO_DETAILS');
          commit("SET_SALARY_INFO_LOADING", false);
          reject(error);
        });
    });
  },

  saveSalaryInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      apiClient.post('/auth/hrm/save-update-salary-info', data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  deleteSalaryInfo({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiClient.delete(`/auth/hrm/delete-salary-info/${id}`)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  getHrmEmployeeSalaryDistribution({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeSalaryDistribution)
        .then(function (response) {
          commit("SET_EMPLOYEE_SALARY_DISTRIBUTION",response.data.data)
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit("UNSET_EMPLOYEE_SALARY_DISTRIBUTION")
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
